/*
 * @Author: Songlongfei 
 * @Date: 2019-03-05 15:41:11 
 * @Last Modified by: Songlongfei
 * @Last Modified time: 2019-03-05 17:21:54
 * @reference https://blog.csdn.net/huangbaokang/article/details/78465301
 */

function ChineseToNumber(chnStr) {
  this.chnNumChar = {
    零:0,
    一:1,
    二:2,
    三:3,
    四:4,
    五:5,
    六:6,
    七:7,
    八:8,
    九:9
  };
  this.chnNameValue = {
    十:{value:10, secUnit:false},
    百:{value:100, secUnit:false},
    千:{value:1000, secUnit:false},
    万:{value:10000, secUnit:true},
    亿:{value:100000000, secUnit:true}
  }
}

ChineseToNumber.prototype.transform = function (chnStr){
  var rtn = 0;
  var section = 0;
  var number = 0;
  var secUnit = false;
  var str = chnStr.split('');

  if(str.length === 2) {
    var num1 = this.chnNumChar[str[0]];
    var num2 = this.chnNumChar[str[1]];
    if(num1 == undefined) {
      return 10 + num2;
    }
    if(num2 == undefined && str[1] == '百') {
      return num1 * 100;
    } else if(num2 == undefined) {
      return num1 * 10;
    }
  }
  for(var i = 0, len = str.length; i < len; i++) {
    if(len == 1 && str[0] == '十') {
      return 10;
    }
    var num = this.chnNumChar[str[i]];
    if(typeof num !== 'undefined'){
      number = num;
      if(i === str.length - 1){
        section += number;
      }
    }else{
      var unit = this.chnNameValue[str[i]].value;
      secUnit = this.chnNameValue[str[i]].secUnit;
      if(secUnit){
        section = (section + number) * unit;
        rtn += section;
        section = 0;
      }else{
        section += (number * unit);
      }
      number = 0;
    }
  }
  return rtn + section;
}

module.exports = ChineseToNumber;
